<template>
  <router-view />
</template>

<script>
export default {
  name: 'PayDayInterestRate'
}
</script>

<style scoped>

</style>
